module.exports = __webpack_public_path__ + "img/guize.13000de6.png";